"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actor_abstract_path_1 = require("@comunica/actor-abstract-path");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var asynciterator_1 = require("asynciterator");

var asynciterator_promiseproxy_1 = require("asynciterator-promiseproxy");

var rdf_string_1 = require("rdf-string");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica Path OneOrMore Query Operation Actor.
 */


var ActorQueryOperationPathOneOrMore =
/*#__PURE__*/
function (_actor_abstract_path_) {
  _inherits(ActorQueryOperationPathOneOrMore, _actor_abstract_path_);

  function ActorQueryOperationPathOneOrMore(args) {
    _classCallCheck(this, ActorQueryOperationPathOneOrMore);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationPathOneOrMore).call(this, args, sparqlalgebrajs_1.Algebra.types.ONE_OR_MORE_PATH));
  }

  _createClass(ActorQueryOperationPathOneOrMore, [{
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(path, context) {
        var _this = this;

        var predicate, sVar, oVar, single, results, o, V, bindingsStream, b, bString, _results, _bindingsStream;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                predicate = path.predicate;
                sVar = path.subject.termType === 'Variable';
                oVar = path.object.termType === 'Variable';

                if (!(!sVar && oVar)) {
                  _context2.next = 17;
                  break;
                }

                // get all the results of applying this once, then do zeroOrMore for those
                single = actor_abstract_path_1.ActorAbstractPath.FACTORY.createPath(path.subject, predicate.path, path.object, path.graph);
                _context2.t0 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 8;
                return this.mediatorQueryOperation.mediate({
                  context: context,
                  operation: single
                });

              case 8:
                _context2.t1 = _context2.sent;
                results = _context2.t0.getSafeBindings.call(_context2.t0, _context2.t1);
                o = rdf_string_1.termToString(path.object); // all branches need to share the same V to prevent duplicates

                V = {};
                bindingsStream = new asynciterator_1.MultiTransformIterator(results.bindingsStream);

                bindingsStream._createTransformer = function (bindings) {
                  var val = bindings.get(o);
                  return new asynciterator_promiseproxy_1.PromiseProxyIterator(
                  /*#__PURE__*/
                  _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee() {
                    var it;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            it = new asynciterator_1.BufferedIterator();
                            _context.next = 3;
                            return _this.ALP(val, predicate.path, context, V, it, {
                              count: 0
                            });

                          case 3:
                            return _context.abrupt("return", it.transform({
                              transform: function transform(item, next) {
                                bindingsStream._push(bus_query_operation_1.Bindings(_defineProperty({}, o, item)));

                                next(null);
                              }
                            }));

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  })), {
                    autoStart: true,
                    maxBufferSize: 128
                  });
                };

                return _context2.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  variables: [o]
                });

              case 17:
                if (!(sVar && oVar)) {
                  _context2.next = 21;
                  break;
                }

                throw new Error('ZeroOrMore path expressions with 2 variables not supported yet');

              case 21:
                if (!(sVar && !oVar)) {
                  _context2.next = 25;
                  break;
                }

                return _context2.abrupt("return", this.mediatorQueryOperation.mediate({
                  context: context,
                  operation: actor_abstract_path_1.ActorAbstractPath.FACTORY.createPath(path.object, actor_abstract_path_1.ActorAbstractPath.FACTORY.createOneOrMorePath(actor_abstract_path_1.ActorAbstractPath.FACTORY.createInv(predicate.path)), path.subject, path.graph)
                }));

              case 25:
                // if (!sVar && !oVar)
                b = this.generateBlankNode();
                bString = rdf_string_1.termToString(b);
                _context2.t2 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 30;
                return this.mediatorQueryOperation.mediate({
                  context: context,
                  operation: actor_abstract_path_1.ActorAbstractPath.FACTORY.createPath(path.subject, predicate, b, path.graph)
                });

              case 30:
                _context2.t3 = _context2.sent;
                _results = _context2.t2.getSafeBindings.call(_context2.t2, _context2.t3);
                _bindingsStream = _results.bindingsStream.transform({
                  filter: function filter(item) {
                    return item.get(bString).equals(path.object);
                  },
                  transform: function transform(item, next) {
                    _bindingsStream._push(bus_query_operation_1.Bindings({}));

                    next(null);
                  }
                });
                return _context2.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: _bindingsStream,
                  variables: []
                });

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x, _x2) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationPathOneOrMore;
}(actor_abstract_path_1.ActorAbstractPath);

exports.ActorQueryOperationPathOneOrMore = ActorQueryOperationPathOneOrMore;